<div class="container">
  <am-app-header (userChange)="onLogin($event)"></am-app-header>
  <rotec-pages-v2>
    @if (isLoggedIn) {
      <a [routerLink]="tenantsLink" routerLinkActive="pages-active-link"
        ><h3 translate>Tenants</h3></a
      >
      <a [routerLink]="usersLink" routerLinkActive="pages-active-link"><h3 translate>Users</h3></a>
      <a [routerLink]="machinesLink" routerLinkActive="pages-active-link">
        <h3 translate>Machines</h3>
      </a>
    }
  </rotec-pages-v2>
</div>
